<script type="text/jsx">
export default {
  name: 'Singleton',
  props: {
    key: String
  },
  created(){
    const regs = (this.constructor.__regs__ = this.constructor.__regs__ || {});
    const key = this.key || this.$slots.default.map(x => x.tag).join('&');
    if(regs[key] == true){
        this.shouldRender = false;
        console.log(`${key} render has been blocked due to singleton warpper`);
    }else{
        this.shouldRender = true;
        regs[key] = true;
    };
  },
  data(){
    return {
        shouldRender: false,
    }
  },
  render() {
    return this.shouldRender ? this.$slots.default : null;
  },
};
</script>
